module.exports = __webpack_public_path__ + "img/list-item-row-left.7dcbc52f.svg";